import React from 'react';
import {useTranslation} from 'react-i18next';

import {ProtectForm} from './ProtectForm';
import CheckinNavigation from 'components/acommon/CheckinNavigation';
import Page from 'components/acommon/Page';

import {DimensionsWrapper} from 'styled/common';

function ProtectScreen() {
  const {t} = useTranslation();
  return (
    <Page showFooterOnlyMobile paddingBottomMobileFooter>
      <CheckinNavigation title={t('property_protection')} />
      <DimensionsWrapper>
        <ProtectForm />
      </DimensionsWrapper>
    </Page>
  );
}

export {ProtectScreen};
